import groq from 'groq';

export const PRODUCT_SLUG = groq`
  "slug": store.slug.current
`;
